<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah Kategori Obat'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'medicine-categories'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/medicine-categories/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Kategori Obat", route: "" },
      { title: "Daftar Kategori Obat", route: "/masters/medicine-categories/list" },
      { title: "Tambah" },
    ])
  },

}

</script>